import { DOM_IDS, QUERY_SELECTORS } from '../utils/constants';
import { setCheckboxById } from '../utils/common';
export default function unsubscribeAll() {
  const unsubscribeAll = document.getElementById(DOM_IDS.unsubscribeAll);
  if (unsubscribeAll) {
    unsubscribeAll.addEventListener('change', function (e) {
      const checkBox = e.target;
      if (checkBox.checked) {
        const items = document.querySelectorAll(QUERY_SELECTORS.subscriptionItem);
        for (let i = 0; i < items.length; ++i) {
          const item = items[i];
          const checkbox = item.querySelector(QUERY_SELECTORS.inputCheckbox);
          setCheckboxById(checkbox.id, false);
        }
      }
    });
  }
}